module.exports = __webpack_public_path__ + "static/media/ic_player_play.ff7ef223.svg";